<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-discipline-type-of-misconduct-dialog-create
          v-if="$hasPermissionTo(['create type of misconducts'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Type of Misconduct's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in type of misconducts here"
          append-icon="search"
          label="Search Type of Misconduct"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredTypeOfMisconducts"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <span v-html="item.name" />
      </template>
    
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-discipline-type-of-misconduct-dialog-edit
            v-if="$hasPermissionTo(['update type of misconducts'])"
            :type-of-misconduct="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-discipline-type-of-misconduct-dialog-delete
            v-if="$hasPermissionTo(['delete type of misconducts'])"
            :type-of-misconduct="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-discipline-type-of-misconduct-dialog-restore
            v-if="$hasPermissionTo(['restore type of misconducts'])"
            :type-of-misconduct="item"
            @restored="loadData"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDisciplineTypeOfMisconductDialogCreate: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogCreate'),
      SetupDisciplineTypeOfMisconductDialogDelete: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogDelete'),
      SetupDisciplineTypeOfMisconductDialogRestore: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogRestore'),
      SetupDisciplineTypeOfMisconductDialogEdit: () => import('@/components/hris/setup/disciplines/type-of-misconduct/DialogEdit'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Type of Misconduct Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Type of Misconducts',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        typeOfMisconducts: [],
        trashedTypeOfMisconducts: [],
      }
    },
    computed: {
      filteredTypeOfMisconducts () {
        return this.statusFilter ? this.typeOfMisconducts : this.trashedTypeOfMisconducts
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.typeOfMisconducts().list(),
          this.$api.typeOfMisconducts().listTrashed(),
        ]).then(([typeOfMisconduct, trashedTypeOfMisconduct]) => {
          this.typeOfMisconducts = typeOfMisconduct.data
          this.trashedTypeOfMisconducts = trashedTypeOfMisconduct.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
